export interface CustomerFormTexts {
  customerInShowroomLabel: string;
  addCoapplicantToggleLabel: string;
  coapplicant: {
    title: string;
    firstName: string;
    lastName: string;
    middleName?: string;
    email: string;
    homePhone: string;
    mobilePhone: string;
  };
  coapplicantAddress: {
    title: string;
    streetAddress: string;
    apt: string;
    city: string;
    state: string;
    zip: string;
    county: string;
  };
  contact: {
    title?: string;
    firstName: string;
    middleName?: string;
    lastName: string;
    email: string;
    homePhone?: string;
    mobilePhone?: string;
  };
  lead: {
    title?: string;
    type: string;
    source: string;
    secondary: string;
    trackingCode: string;
  };
  address: {
    title?: string;
    streetAddress: string;
    apt: string;
    city: string;
    state: string;
    zip: string;
    county: string;
  };
  addAddressText?: string;
  resetCreditAppConfirmation: {
    description: string;
    cancel: string;
    continue: string;
  };
}

export const defaultCustomerFormTexts = {
  customerInShowroomLabel: 'Customer in showroom',
  addCoapplicantToggleLabel: 'Add coapplicant',
  coapplicant: {
    title: 'Coapplicant info',
    firstName: 'First name',
    middleName: 'Middle name',
    lastName: 'Last name',
    email: 'Email',
    homePhone: 'Home phone',
    mobilePhone: 'Mobile phone',
  },
  coapplicantAddress: {
    title: 'Coapplicant address',
    streetAddress: 'Street address',
    apt: 'Apt, Unit',
    city: 'City',
    state: 'State',
    zip: 'Zip',
    county: 'County',
  },
  contact: {
    title: 'Contact info',
    firstName: 'First name',
    middleName: 'Middle name',
    lastName: 'Last name',
    email: 'Email',
    homePhone: 'Home phone',
    mobilePhone: 'Mobile phone',
  },
  lead: {
    title: 'Lead info',
    type: 'Lead type',
    source: 'Lead Source',
    secondary: 'Opportunity source',
    trackingCode: 'Tracking source',
  },
  address: {
    title: 'Address',
    streetAddress: 'Street address',
    apt: 'Apt, Unit',
    city: 'City',
    state: 'State',
    zip: 'Zip',
    county: 'County',
  },
  addAddressText: 'Add',
  resetCreditAppConfirmation: {
    description:
      'Are you sure you want to make changes to your existing deal? This will require you to resubmit your credit application.',
    cancel: 'No, let me stick with my current deal.',
    continue: "Yes, let's proceed with changes.",
  },
} satisfies CustomerFormTexts;
